import { DEFAULT_DEADLINE } from "../constants";
const calculateDeadline = (daysFromNow = DEFAULT_DEADLINE) => {
  const daysInSeconds = daysFromNow * 24 * 60 * 60;
  const currentTimeStamp = Math.floor(Date.now() / 1e3);
  const deadline = currentTimeStamp + daysInSeconds;
  return BigInt(deadline);
};
export {
  calculateDeadline
};
//# sourceMappingURL=time.mjs.map